import moment from 'moment'
import { GraviGrid, Horizontal } from '@gravitate-js/excalibrr'
import { getColumnDefs } from '../columnDefs'
import { useAnalyticsReporting } from '@api/useAnalyticsReporting'
import { useUserSettings } from '@hooks/settings'
import { DateRangeFilter } from '@components/_SiteWide/Grid/ActionButtons/DateRangeFilter'
import { useMemo, useRef } from 'react'
import { useDateRangeFilter } from '@hooks/useDateRangeFilter'
import { DownloadButton } from '@components/_SiteWide/Grid/ActionButtons/DownloadButton'

export function TaxValuations() {
  const gridAPIRef = useRef(null)
  const { useTaxesOverview, useRecalculateTaxesMutation } = useAnalyticsReporting()
  const recalculateTaxes = useRecalculateTaxesMutation()
  const { updateSetting } = useUserSettings()
  const columnDefs = useMemo(() => getColumnDefs('tax-valuations', recalculateTaxes), [])

  const { filters, setFilters, dayRangeStorage, setDayRange } = useDateRangeFilter(
    'analytics-reporting-tax-valuations',
    {
      back: -3,
      ahead: 3,
    }
  )

  const { data, isFetching } = useTaxesOverview({
    start: moment(filters.From).format('YYYY-MM-DDT00:00:00'),
    end: moment(filters.To).format('YYYY-MM-DDT00:00:00'),
  })

  return (
    <GraviGrid
      storageKey='tax-valuations'
      rowData={data?.rows ?? []}
      loading={isFetching}
      columnDefs={columnDefs}
      externalRef={gridAPIRef}
      primaryKey='id'
      controlBarProps={{
        title: 'Tax Valuations',
        actionButtons: (
          <Horizontal verticalCenter gap='1em'>
            <DateRangeFilter
              getFromStorage
              currentFilters={filters}
              setCurrentFilters={setFilters}
              dayRangeStorage={dayRangeStorage}
              setDayRangeStorage={setDayRange}
              defaultSliderValues={[-3, 3]}
            />
            <DownloadButton fileName='Tax Valuations' gridAPIRef={gridAPIRef} />
          </Horizontal>
        ),
      }}
      agPropOverrides={{
        getRowId: (row) => row?.data?.id,
      }}
      onGridConfigChanged={(config) => updateSetting('gridConfig::tax-valuations', config)}
    />
  )
}
